Controller = App.loadClass 'core::Angular/Controller'

class exports.SidebarController extends Controller

    constructor: (@scope, @transitions, @state, FilterService, @timeout) ->
        super(@scope, @transitions)
        @scope.service = FilterService
        @scope.service.filter_url = 'backend/portal/customers/filters'
        @scope.service.setDefinitions @defineFilterLayout()

        # Trigger first load of report
        @scope.$on 'Customers:init', () =>
            @scope.$broadcast 'Customers:run', @filters

        @scope.$watch () =>
            @scope.service.current_filters
        , (current_filters) =>
            @filters = current_filters

            # Rerun report when filters are applied
            @scope.$broadcast 'Customers:run', @filters

        # If we have loaded the sidebar go ahead and load the report
        if @state.current.name is 'portal.customers'
            @timeout () =>
                @state.go '.fullpage', @state.params, location: false

    defineFilterLayout: () =>
        currentYear = moment().year()
        return [
            name: 'Filters',
            filters: [
                name: 'years'
                display_name: 'Year'
                control_type: 'single_dropdown'
                deletable: false
                selected_values: [
                    key: currentYear
                    value: currentYear
                ]
            ,
                name: 'crops'
                display_name: 'Crop'
            ]
        ]